export const DEFAULT_TEXT_BUTTON_HEIGHT = 24
